import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../../Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "../../Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import KycPlaidEmailRequest from "../../Communication/ApiClasses/KycPlaidEmailRequest";

// worker
function* handleAction(action) {
  yield put(doLoadingStart(actionTypes.KYC_PLAID_EMAIL));

  const kycPlaidEmailRequest = new KycPlaidEmailRequest(action.data);
  try {
    const result = yield call(kycPlaidEmailRequest.getData);
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: `${actionTypes.KYC_PLAID_EMAIL}_ERROR`,
      error,
    });
  } finally {
    yield put(doLoadingFinish(actionTypes.KYC_PLAID_EMAIL));
  }
}

// watcher
export default function* handleSaga() {
  yield takeLatest(actionTypes.KYC_PLAID_EMAIL, handleAction);
}
